import { render, staticRenderFns } from "./JumpDeckOnComponent.vue?vue&type=template&id=1f07f840"
import script from "./JumpDeckOnComponent.vue?vue&type=script&lang=js"
export * from "./JumpDeckOnComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports